module.exports = __webpack_public_path__ + "statics/img/cate2-4@2x.071e183d.png";